import React from "react";
var __jsx = React.createElement;
import { TrackingReturnWizardProvider, useTrackingReturnWizard } from "@/pages/tracking/trackingReturn/TrackingReturnWizardContext";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import useHelpers from "@hooks/useHelpers";
import TrackingFinanceReturn from "@/pages/tracking/trackingReturn/TrackingFinanceReturn/TrackingFinanceReturn";
import TrackingFinanceReturnForm from "@/pages/tracking/trackingReturn/TrackingFinanceReturnForm/TrackingFinanceReturnForm";
import ReturnThankYouPage from "@/pages/tracking/trackingReturn/TrackingFinanceReturnForm/components/ReturnThankYouPage";
import { useTranslation } from "@i18n";
import TechnicalError from "@/pages/tracking/trackingReturn/TrackingFinanceReturnForm/components/TechnicalError";
var TrackingReturnWizard = function TrackingReturnWizard() {
  var params = useParams();
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useState = useState({
      order_id: null,
      order_uuid: null,
      order_type: null,
      isFinance: null,
      city_id: null
    }),
    orderData = _useState[0],
    setOrderData = _useState[1];
  useEffect(function () {
    var dataInSession = JSON.parse(sessionStorage.getItem("orderData-".concat(params.order_uuid)));
    setOrderData(dataInSession);
    console.log(dataInSession, "");
    if (!dataInSession || dataInSession.order_uuid !== params.order_uuid) {
      // navigate to the previous page
      navigateTo("/tracking-landing");
    }
  }, [params.order_uuid]);
  return /*#__PURE__*/React.createElement(TrackingReturnWizardProvider, {
    orderDataInSession: orderData
  }, /*#__PURE__*/React.createElement(WizardContent, null));
};
var WizardContent = function WizardContent() {
  var _useTrackingReturnWiz = useTrackingReturnWizard(),
    currentStep = _useTrackingReturnWiz.currentStep,
    orderData = _useTrackingReturnWiz.orderData,
    goToStep = _useTrackingReturnWiz.goToStep;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers2 = useHelpers(),
    navigateTo = _useHelpers2.navigateTo;
  switch (currentStep.toString()) {
    case "confirm":
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TrackingFinanceReturn, null));
    case "form":
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TrackingFinanceReturnForm, null));
    case "success":
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ReturnThankYouPage, null));
    case "error":
      return /*#__PURE__*/React.createElement(TechnicalError, {
        text: t("error_technical_error_occurred", {
          ns: "web_tracking"
        }),
        onClickHome: function onClickHome() {
          return navigateTo("/");
        },
        onClickMain: function onClickMain() {
          return navigateTo("/tracking-landing");
        }
      });
    default:
      return /*#__PURE__*/React.createElement(TechnicalError, {
        text: t("error_technical_error_occurred", {
          ns: "web_tracking"
        }),
        onClickHome: function onClickHome() {
          return navigateTo("/");
        },
        onClickMain: function onClickMain() {
          return navigateTo("/tracking-landing");
        }
      });
  }
};
export default TrackingReturnWizard;